export class CancerTreatmentModel{
  patientcode = '' ;
  trdate = '2024-01-01' ;
  trdateID = '2024-01-01' ;
  trtime = '2024-01-01' ;
  trlocation = '' ;
  trtype = '' ;
  trtypeID = '';
  trkindid ='';
  trtechnique = '';
  trkind = '' ;
  wk_kind ='';
  trunit = '';
  trunitname = '';
  trcycleno = '' ;
  wk_trcycleno = ''
  wk_Pervious = ''
  trdayscycle = '' ;
  trnotes = '' ;
  trstartdate = '2024-01-01' ;
  trenddate = '2024-01-01' ;
  trdose = 0 ;
  wk_title_of_Dose_FractionText = ''
  trdoseunit ='';
  trdosemod = 0;
  trdosemodtext = '';
  trfrac = 0 ;
  trdosefrac = 0 ;
  userid = '' ;
  username = '' ;
  usernameCheck = '' ;
  trconsultant = '';
}
